import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { IconChevronRight } from '@noths/polaris-client-ribbons-design-system';
import * as styles from "../styles/NavigationDrilldownList.styles";
import { useTracking } from "../hooks/useTracking/useTracking";
var ICON_SIZE = 16;
export var NavigationDrilldownList = function NavigationDrilldownList(_ref) {
  var disabled = _ref.disabled,
    expandedIndex = _ref.expandedIndex,
    getExpandedIndex = _ref.getExpandedIndex,
    items = _ref.items,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 0 : _ref$level,
    onSelect = _ref.onSelect,
    setExpandedIndex = _ref.setExpandedIndex;
  var tracking = useTracking();
  return /*#__PURE__*/React.createElement(_StyledUl, {
    $_css: styles.list
  }, items === null || items === void 0 ? void 0 : items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.title,
      style: {
        '--color': item.color
      }
    }, item.url && (!item.items || item.items.length === 0) ?
    /*#__PURE__*/
    // Leaf node: render as link
    React.createElement(_StyledA, {
      href: item.url,
      onClick: function onClick(evt) {
        return tracking.onClickLink(evt, item);
      },
      tabIndex: disabled ? -1 : 0,
      $_css2: [styles.button, styles.link, item.role === 'see_all_link' && styles.seeAllLink]
    }, item.title) :
    /*#__PURE__*/
    // Has children: render as button to drill down
    React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledButton, {
      disabled: disabled,
      onClick: function onClick() {
        onSelect(item);
        tracking.onSelect(item);
        setExpandedIndex(expandedIndex === idx ? null : idx, level);
      },
      $_css3: styles.button
    }, item.title, /*#__PURE__*/React.createElement(IconChevronRight, {
      height: ICON_SIZE,
      width: ICON_SIZE
    })), item.items && item.items.length > 0 && expandedIndex === idx && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavigationDrilldownList, {
      disabled: disabled,
      expandedIndex: getExpandedIndex ? getExpandedIndex(level + 1) : null,
      getExpandedIndex: getExpandedIndex,
      items: item.items,
      level: level + 1,
      onSelect: onSelect,
      setExpandedIndex: setExpandedIndex
    }))));
  }));
};
var _StyledUl = _styled("ul")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledA = _styled2("a")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledButton = /*#__PURE__*/_styled3("button").withConfig({
  displayName: "NavigationDrilldownList___StyledButton",
  componentId: "sc-r02916-0"
})(["", ""], function (p) {
  return p.$_css3;
});